import React from "react";
import Nav from "../component/Nav";
import Footer from "../component/Footer";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #fffaf3 0%, #f7f3ff 100%)",
    color: "#2d1b12",
    fontFamily: "Arial, sans-serif",
    padding: "48px 20px",
  },
  container: {
    maxWidth: "980px",
    margin: "0 auto",
    background: "#ffffff",
    borderRadius: "20px",
    boxShadow: "0 20px 60px rgba(93, 60, 30, 0.12)",
    overflow: "hidden",
  },
  header: {
    background: "linear-gradient(135deg, #ffedd5 0%, #f6d3ff 100%)",
    padding: "48px 40px 32px",
    borderBottom: "1px solid #f3e7de",
  },
  eyebrow: {
    margin: "0 0 8px",
    color: "#8a4d21",
    fontSize: "13px",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  title: {
    margin: "0",
    fontSize: "clamp(2.2rem, 5vw, 3.5rem)",
    lineHeight: 1.1,
    color: "#2d1b12",
  },
  subtext: {
    margin: "14px 0 0",
    color: "#5a4036",
    fontSize: "1rem",
    lineHeight: 1.7,
  },
  content: {
    padding: "32px 40px 48px",
  },
  section: {
    marginBottom: "30px",
  },
  sectionTitle: {
    margin: "0 0 14px",
    fontSize: "1.45rem",
    color: "#3f250d",
  },
  text: {
    margin: "0 0 14px",
    color: "#43352f",
    lineHeight: 1.8,
    fontSize: "1rem",
  },
  list: {
    margin: "0 0 0 18px",
    padding: 0,
    color: "#43352f",
    lineHeight: 1.8,
    fontSize: "1rem",
  },
  strong: {
    color: "#2d1b12",
    fontWeight: 700,
  },
  callout: {
    background: "#fff8ee",
    border: "1px solid #f1d9b7",
    borderRadius: "14px",
    padding: "18px 20px",
    color: "#4f3528",
    marginTop: "10px",
  },
};

const TermsOfService = () => {
  return (
    <>
    <Nav/>
    <br/>
    <br/>
    <br/>
    <div style={styles.page}>
      <div style={styles.container}>
        <header style={styles.header}>
          <p style={styles.eyebrow}>Swingwings Books</p>
          <h1 style={styles.title}>Terms of Service</h1>
          <p style={styles.subtext}>
            These terms govern your use of Swingwings, our online bookstore,
            and any services we provide for families, educators, and young
            readers.
          </p>
        </header>

        <main style={styles.content}>
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>1. Introduction</h2>
            <p style={styles.text}>
              Welcome to <span style={styles.strong}>Swingwings</span>, a
              children’s bookstore designed to make reading joyful, safe, and
              easy for families. By shopping with us, creating an account, or
              using our website, you agree to these Terms of Service. If you do
              not agree, please do not use our site.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>2. Eligibility</h2>
            <p style={styles.text}>
              Our store is intended for customers who are at least 18 years old
              or who are purchasing on behalf of a child with parental/guardian
              consent. Parents and guardians are responsible for monitoring
              their children’s access and use of our products and website.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>3. Product Information</h2>
            <p style={styles.text}>
              We aim to provide accurate product descriptions, age
              recommendations, pricing, and availability. Please note that item
              photos, illustrations, and summaries are for general guidance and
              may not always reflect the exact edition or print quality.
            </p>
            <ul style={styles.list}>
              <li>Age ranges and reading levels are recommendations only.</li>
              <li>Stock availability may change without notice.</li>
              <li>
                Some titles may be limited edition, pre-order, or temporarily
                unavailable.
              </li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>4. Orders and Payments</h2>
            <p style={styles.text}>
              By placing an order, you confirm that all information provided is
              accurate and complete. We reserve the right to refuse or cancel
              orders if we suspect fraud, misuse of our system, or any violation
              of these terms.
            </p>
            <ul style={styles.list}>
              <li>Prices are listed in the currency shown at checkout.</li>
              <li>Payment must be authorized before an order is processed.</li>
              <li>We may contact you to verify details before shipping.</li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>5. Shipping and Delivery</h2>
            <p style={styles.text}>
              We will do our best to process and ship orders promptly. Delivery
              times are estimates and may vary by location, holidays, carrier
              delays, or supply chain issues.
            </p>
            <ul style={styles.list}>
              <li>Shipping fees are calculated at checkout.</li>
              <li>
                We are not responsible for delays caused by third-party
                carriers.
              </li>
              <li>
                Delivery to incorrect addresses due to inaccurate customer
                information is the customer’s responsibility.
              </li>
            </ul>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>
              6. Returns, Exchanges, and Damages
            </h2>
            <p style={styles.text}>
              We want every child to love their books. If an item arrives
              damaged, incorrect, or defective, please contact us within a
              reasonable time after receipt. We may offer a replacement, refund,
              or store credit depending on the issue and circumstances.
            </p>
            <div style={styles.callout}>
              Please include your order number, the product name, and clear
              photos of any damage when contacting customer support.
            </div>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>
              7. Content and Age Appropriateness
            </h2>
            <p style={styles.text}>
              We curate books for a wide age range, from picture books to
              chapter books and young readers. Parents and guardians are
              responsible for choosing books suitable for their child’s reading
              level and maturity. We do not guarantee that all content is
              appropriate for every child.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>8. Intellectual Property</h2>
            <p style={styles.text}>
              All content on our site, including text, artwork, logos, designs,
              and product images, is owned by Swingwings or licensed for use.
              You may not copy, reproduce, distribute, or exploit any part of
              our website or content without written permission.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>9. User Accounts</h2>
            <p style={styles.text}>
              If you create an account, you are responsible for keeping your
              login information secure and accurate. You agree not to use
              someone else’s identity or attempt to access another user’s
              account.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>10. Privacy</h2>
            <p style={styles.text}>
              We collect and use personal information to process orders, improve
              your shopping experience, and communicate with you. We are
              committed to protecting your information and handling it in
              accordance with our privacy policy.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>11. Limitation of Liability</h2>
            <p style={styles.text}>
              Swingwings is not liable for indirect, incidental, special, or
              consequential damages arising from your use of our site, products,
              or services. Our maximum liability is limited to the amounts paid
              for the specific order giving rise to the claim.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>12. Changes to These Terms</h2>
            <p style={styles.text}>
              We may update these Terms of Service from time to time. Any
              changes will be posted on this page with a revised date. Continued
              use of our website after changes are posted means you accept the
              revised terms.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>13. Contact Us</h2>
            <p style={styles.text}>
              If you have questions about these Terms of Service, please reach
              out to our customer care team at{" "}
              <span style={styles.strong}>hello@Swingwingsbooks.com</span> or
              by phone at <span style={styles.strong}>+1 (800) 555-0199</span>.
            </p>
          </section>
        </main>
      </div>
      
    </div>
    <Footer/>
    </>
  );
};

export default TermsOfService;
